<template>
  <div class="system_title_box">
    <div class="system_title">{{posData}}</div>
  </div>
</template>

<script>
export default {
  name: 'pos_title_top',
  props: ['posData', 'systemTitle'],
  data () {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
.system_title_box{
  color: rgb(27, 61, 109);
  font-size:1.25rem ;
  font-weight: 700;
  height: 3.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to right, rgb(237, 240, 242) ,rgba(237, 240, 242, 0.06));
  .system_title{
    width: 75rem;
    padding-left: 10px;
    //background: #ff6700;
  }
}

</style>



// WEBPACK FOOTER //
// src/comm/components/pos_title_top.vue